import { NgModule } from '@angular/core';
import { ScrollerComponent } from './scroller.component';
import { RdsIconsModule, RdsButtonModule } from '@rds/angular-components';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    ScrollerComponent,
  ],
  imports: [
    CommonModule,
    RdsButtonModule,
    RdsIconsModule
  ],
  exports: [
    ScrollerComponent
  ]
})
export class ScrollerModule { }